module.exports = __webpack_public_path__ + "img/logo-airWallex.723075c9.svg";